import { useState } from 'react';
import Select from '../../../components/Select';
import { config } from '../../../config/config';
import { LockUpType } from '../../../context/pool/poolTypes';
import { formatUSD } from '../../../helpers';
import PoolSummaryHeader from '../PoolSummaryHeader';
import LockedDeposit from './LockedDeposit';
// import useUserLockedDeposits from '../../../hooks/web3/pools/useUserLockedDeposits';
import useMockUserLockedDeposits from '../../../hooks/web3/pools/useMockUserLockedDeposits';
import Card from '../../../components/Card';
import Spinner from '../../../components/Spinner';
import { formatUnits, parseUnits } from 'ethers/lib/utils';
// import useUserTotalDeposits from '../../../hooks/web3/pools/useUserTotalDeposits';
import useMockUserTotalDeposits from '../../../hooks/web3/pools/useMockUserTotalDeposits';

const PoolLockedDeposits = () => {
    const [filter, setFilter] = useState<LockUpType | undefined>(undefined);

    // const { isLoading, userLockedDeposits } = useUserLockedDeposits();
    const { isLoading, userLockedDeposits } = useMockUserLockedDeposits();
    // const { userTotalDeposits } = useUserTotalDeposits();
    const { userTotalDeposits } = useMockUserTotalDeposits();

    const lockedPoolPositions = userTotalDeposits
        ? userTotalDeposits.totalDepositsPerPool.reduce(
              (total, { lockedTotalAssets, liquidityPool: lockedPool }) => {
                  return formatUnits(
                      parseUnits(total, lockedPool.decimals).add(
                          parseUnits(lockedTotalAssets, lockedPool.decimals)
                      ),
                      lockedPool.decimals
                  );
              },
              '0'
          )
        : undefined;

    const unlockedPoolPositions = userTotalDeposits
        ? userTotalDeposits.totalDepositsPerPool.reduce(
              (total, { unlockedTotalAssets, liquidityPool: lockedPool }) => {
                  return formatUnits(
                      parseUnits(total, lockedPool.decimals).add(
                          parseUnits(unlockedTotalAssets, lockedPool.decimals)
                      ),
                      lockedPool.decimals
                  );
              },
              '0'
          )
        : undefined;

    const filtered = userLockedDeposits
        ? userLockedDeposits.filter(({ lockUpType }) =>
              filter ? lockUpType.lockUpId === filter?.lockUpId : true
          )
        : [];

    return (
        <div className='pool-locked-deposits-container'>
            <Card className='summary-header-container'>
                <PoolSummaryHeader
                    title='Current Locked Pool Positions'
                    value={
                        lockedPoolPositions
                            ? formatUSD(lockedPoolPositions, {
                                  minDecimals: 2,
                              })
                            : '-'
                    }
                />
                <PoolSummaryHeader
                    title='Current Unlocked Pool Positions'
                    value={
                        unlockedPoolPositions
                            ? formatUSD(unlockedPoolPositions, {
                                  minDecimals: 2,
                              })
                            : '-'
                    }
                />
            </Card>
            <div className='lock-up-filter-container'>
                <Select
                    options={[undefined, ...config.lockUpOptions]}
                    optionKey={'duration'}
                    onChange={(option) => setFilter(option)}
                    renderOption={(option) => (
                        <>
                            {option
                                ? option.duration === undefined
                                    ? 'No Lock'
                                    : `${option.duration} days`
                                : 'All'}
                            <span>&nbsp;positions</span>
                        </>
                    )}
                    renderSelected={(option) => (
                        <>
                            {option
                                ? option.duration === undefined
                                    ? 'No Lock'
                                    : `${option.duration} days`
                                : 'All'}
                            &nbsp;
                            <span>positions</span>
                        </>
                    )}
                />
            </div>
            <div className='deposits-container'>
                {isLoading ? (
                    <Card className='deposit-text'>
                        <div className='loading-container'>
                            <Spinner />
                            <span>Loading your deposits...</span>
                        </div>
                    </Card>
                ) : userLockedDeposits ? (
                    filtered.length ? (
                        filtered.map((userDeposit, index) => (
                            <LockedDeposit key={index} deposit={userDeposit} />
                        ))
                    ) : (
                        <Card className='deposit-text'>
                            You have no&nbsp;
                            <strong>
                                {filter?.duration
                                    ? `${filter.duration} days lock`
                                    : 'No-Lock'}
                            </strong>
                            &nbsp;positions locked...
                        </Card>
                    )
                ) : (
                    <Card className='deposit-text'>
                        We had trouble loading your deposits...
                    </Card>
                )}
            </div>
        </div>
    );
};

export default PoolLockedDeposits;
